;$(function(){
	$('.J_gender_male').find('span').on('click', function(){
		$('.J_gender_female').find('span').eq($(this).data('value')).addClass('active').siblings('span').removeClass('active')
			.siblings('input').val($(this).data('value')?0:1);
	});
	$('.J_gender_female').find('span').on('click', function(){
		$('.J_gender_male').find('span').eq($(this).data('value')).addClass('active').siblings('span').removeClass('active')
			.siblings('input').val($(this).data('value')?0:1);
	});
});
